import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    debug: false,
    interpolation: { escapeValue: false },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    // Every namespace consumed via useTranslation("<ns>") MUST be listed here
    // react-i18next defaults to useSuspense:true, so a component that requests
    // an unlisted namespace suspends synchronously during render and crashes
    // the page with React error #426 (see src/lib/i18n/__tests__/i18n.test.ts).
    ns: ["common", "dashboard", "cashbook", "classes", "payments", "pos", "report-builder", "leads", "maintenance", "retention", "integrations", "statement", "nps", "induction", "notifications", "inventory", "faq", "nutrition", "whatsapp", "getting-started"],
    defaultNS: "common",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "gymviz.locale",
    },
  });

i18n.on("languageChanged", (lng) => {
  const html = document.documentElement;
  html.lang = lng;
  html.dir = lng === "ar" ? "rtl" : "ltr";
});

export default i18n;
